import axios from 'axios'
import { getAPIService } from '../../getServerHost'
import { User } from '../../types'

export const userCreate = async (payload: User) => {
  const response = await axios.post(`${getAPIService}/users`, payload)
  return response.data
}
